/**
 * Playhead Component
 * Timeline playhead indicator showing current playback position
 */

import React from 'react';

export const Playhead = ({
  currentTime,
  totalDuration,
  zoom,
}) => {
  return (
    <div
      className="absolute top-0 bottom-0 w-0.5 bg-indigo-500 z-20 pointer-events-none shadow-[0_0_10px_rgba(99,102,241,0.5)]"
      style={{ left: `${(currentTime / totalDuration) * 100 * zoom}%` }}
      data-testid="playhead"
    >
      <div className="w-3 h-3 bg-indigo-500 rounded-full -ml-[5px] -mt-1 shadow-lg" />
    </div>
  );
};

export default Playhead;
